<template lang="html">
  <div class="inner-modal lcbcft" :class="{ high: filling }">
  	<div class="head-modal row">
  		<div class="title column">
  			<div class="head-modal-title">
  				Questionnaire
  			</div>
				<div class="head-modal-emphase">
					Lutte contre le blanchiment des capitaux </br>
					et le financement du terrorisme
				</div>
  		</div>
  	</div>
		<div class="body-modal" v-if="filling">
			<form class="form-ui column default-form-ui">
				<div class="ctn-field">
					<div class="label">
						Date de mise en relation
					</div>
					<div class="ctn-date-input">
						<input-date v-model="date" />
					</div>
				</div>
				<div class="ctn-field">
					<div class="label">
						Origine de la relation client
					</div>
					<custom-select v-model="origin" :items="origins" :solo="true" />
				</div>
				<div class="ctn-field">
					<div class="label">
						Ouverture à distance
					</div>
					<div class="sublabel">
						Vigilance accrue exigée lorsque le client ou son représentant légal n'est pas physiquement présent au fins de l'identification (Art. L.561-10 1° du code monétaire et financier)
					</div>
					<custom-toggle v-model="remoteContractualization" />
				</div>
				<div class="ctn-field">
					<div class="label">
						Catégorie professionnelle
					</div>
					<custom-select v-validate="'required|select'" name="catégorie professionnelle" v-model="professionalCategory" :items="professionnalCategories" :solo="true" />
					<div class="error-message">{{ errors.first('catégorie professionnelle')}}</div>
				</div>
				<div class="ctn-field">
					<div class="label">
						Activité risquée
					</div>
					<div class="sublabel">
						Il s'agit de savoir si l'activité du client est plus ou moins risquée au sens du risque de blanchiment/financement du terrorisme
					</div>
					<custom-toggle v-model="activityRisk" />
				</div>
				<div class="ctn-field">
					<div class="label">
						Soupçon de fraude fiscale
					</div>
					<a href="https://s3.eu-west-3.amazonaws.com/patrimoffice/public/Info-Soupc%CC%A7on-Fraude-Fiscale.pdf" target="_blank" class="sublink"><span class="icon-info-2"></span> Plus d'informations sur le soupçon de fraude fiscale</a>
					<custom-toggle v-model="suspicionOfFraud" />
				</div>
				<div class="ctn-field">
					<div class="label">
						Le client exerce-t-il ou a-t-il exercé au cours des 12 derniers mois une fonction politique, juridictionnelle ou administrative importante ?
					</div>
					<a href="https://s3.eu-west-3.amazonaws.com/patrimoffice/public/Infos-PPE.pdf" target="_blank" class="sublink"><span class="icon-info-2"></span> Plus d'informations sur les PPE (Personnes Politiquement Exposées)</a>
					<custom-toggle v-model="wasPJA" />
				</div>
				<div class="ctn-field">
					<div class="label">
						Le client a-t-il un lien avec une personne de sa famille ou de son entourage qui exerce ou a exercé au cours des 12 derniers mois une fonction politique, juridictionnelle ou administrative importante ?
					</div>
					<a href="https://s3.eu-west-3.amazonaws.com/patrimoffice/public/Infos-PPE.pdf" target="_blank" class="sublink"><span class="icon-info-2"></span> Plus d'informations sur les PPE (Personnes Politiquement Exposées)</a>
					<custom-toggle v-model="wasSomeonePJA" />
				</div>
				<div class="ctn-field">
					<div class="label">
						Client VIP
					</div>
					<div class="sublabel">
						Un VIP est un personnage publique important
					</div>
					<custom-toggle v-model="isVIP" />
				</div>
				<div class="ctn-field">
					<div class="label">
						Nationalité (Nationalité principale)
					</div>
					<div class="sublabel">
						Choix obligatoire
					</div>
					<custom-select v-validate="'required|select:true'" name="nationalité" v-model="country" :items="countryList" :object="true" :solo="true"/>
					<div class="error-message">{{ errors.first('nationalité')}}</div>
				</div>
				<div class="ctn-field">
					<div class="label">
						Seconde nationalité
					</div>
					<div class="sublabel">
						Choix facultatif
					</div>
					<custom-select v-model="secondCountry" :items="countryList" :object="true" :solo="true"/>
				</div>
				<div class="ctn-field">
					<div class="label">
						Résidence fiscale
					</div>
					<div class="sublabel">
						Choix Obligatoire
					</div>
					<custom-select v-validate="'required|select:true'" name="résidence fiscale" v-model="fiscCountry" :items="countryList" :object="true" :solo="true" />
					<div class="error-message">{{ errors.first('résidence fiscale')}}</div>
				</div>
				<div class="ctn-field">
					<div class="label">
						Banque dépositaire
					</div>
					<div class="sublabel">
						Pays non cooperatifs : Guatemala, Niue, Brunei, Iles Marshall, Iles Vierges britanniques, Jersey, Montserrat, Nauru, Botswana, Bermudes
					</div>
					<custom-select v-model="banqueCountry" :items="banqueCountries" :solo="true" />
				</div>
				<div class="ctn-field">
					<div class="label">
						Poursuite pénale
					</div>
					<custom-toggle v-model="penal" />
				</div>
				<div class="error-message" v-if="errorInForm">Une erreur est présente dans le formulaire</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="sendScore">Calculer le score</div>
				</div>
			</form>
		</div>
		<div class="body-modal" v-else>
			<form class="form-ui column default-form-ui">
				<div class="ctn-result-score row">
					<div class="value" :class="resolveClass()">
						{{ displayScore() }}
					</div>
					<div class="status">
						<div class="name">
							Vigilence <span class="bold">{{ score_label }}</span>
						</div>
						<div class="subname" v-if="score > 3">
							Une alerte va être envoyé aux Super Admin
						</div>
					</div>
				</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="filling=true">Revoir mes réponses</div>
					<div class="btn btn-red" @click="end">Terminer</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
import CountryList from '@/common/components/MyPatrimonialLandscape/data/Country'
import CustomSelect from '@/common/components/Form/CustomSelect'
import inputDate from '@/common/components/Form/InputDate'
import CustomToggle from '@/common/components/Form/CustomToggle'
import UserResource from '@/resources/user'
export default {
	name: 'LCBCFT',
	components: {
		inputDate,
		CustomSelect,
		CustomToggle
	},
	data () {
		return {
			date: new Date(),
			origin: null,
			origins: ['Sollicitation spontanée', 'Prospection', 'Recommendation'],
			remoteContractualization: false,
			professionalCategory: null,
			professionnalCategories: ['-', 'Profession artistique', 'Commerçants et assimilés', 'Profession libérale', 'Toute autre profession'],
			activityRisk: false,
			suspicionOfFraud: false,
			wasPJA: false,
			wasSomeonePJA: false,
			isVIP: false,
			country: null,
			secondCountry: null,
			fiscCountry: null,
			countryList: CountryList,
			banqueCountry: null,
			banqueCountries: ['Union Européenne', 'OCDE Hors UE', 'Pays non coopératif', 'Hors UE'],
			penal: false,
			filling: true,
			score: 2,
			score_label: 'Vigilance normale',
			errorInForm: false
		}
	},
	mounted () {
		this.origin = this.origins[0]
		this.professionalCategory = this.professionnalCategories[0]
		this.banqueCountry = this.banqueCountries[0]
	},
	methods: {
		close () {
			this.$emit('close')
		},
		sendScore () {
			this.errorInForm = false
			this.$validator.validate().then((validation) => {
				if (validation) {
					this.$store.commit('LOADER_IN')
					UserResource.postLCBCFT({
						user_id: this.$router.currentRoute.params.clientId,
						initial_contact_date: this.$moment(this.date).format('YYYY-MM-DD'),
						contact_origin: this.origin,
						// remote_contractualization: (this.remoteContractualization) ? 1 : 0,
						remote_contractualization: this.remoteContractualization,
						professional_category: this.professionalCategory,
						// client_activity_risk: (this.activityRisk) ? 1 : 0,
						client_activity_risk: this.activityRisk,
						// tax_fraud_suspicion: (this.suspicionOfFraud) ? 1 : 0,
						tax_fraud_suspicion: this.suspicionOfFraud,
						// client_exposed: (this.wasPJA) ? 1 : 0,
						client_exposed: this.wasPJA,
						// client_family_exposed: (this.wasSomeonePJA) ? 1 : 0,
						client_family_exposed: this.wasSomeonePJA,
						// client_vip: (this.isVIP) ? 1 : 0,
						client_vip: this.isVIP,
						client_main_nationality: this.country.type,
						client_second_nationality: (this.secondCountry) ? this.secondCountry.type : null,
						tax_residence: (this.fiscCountry) ? this.fiscCountry.type : null,
						bank_deposit_country: this.banqueCountry,
						// penal_action: (this.penal) ? 1 : 0
						penal_action: this.penal
					}).then((result) => {
						this.$store.commit('LOADER_OUT')
						if (result.data.success) {
							this.score = result.data.score
							this.score_label = result.data.label.split(' ')[1]
							this.filling = false
						} else {
							console.log('une erreur est survenue')
						}
					})
				} else {
					this.errorInForm = true
				}
			})
		},
		displayScore () {
			return ('00' + this.score.toString()).slice(-2)
		},
		resolveClass () {
			let style = ''
			if (this.score < 3) {
				style = 'green'
			} else if (this.score < 7) {
				style = 'orange'
			} else {
				style = 'red'
			}

			return style
		},
		end () {
			this.$store.dispatch('sendLCBCFT', {
				user_id: this.$router.currentRoute.params.clientId,
				lcbft_completed: 1
			}).then(() => {
				this.$emit('close')
			}).catch((error) => {
				console.log('Error : ', error)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// LCBCFT.vue?5578f78e